module.exports = Array.isArray;